import { Middleware } from '@reduxjs/toolkit'
import { myAddressesApi } from 'feature/addresses/redux/MyAddresses.api'
import { appealApi } from 'feature/appeals/redux/appeals.api'
import { noticeApi } from 'feature/notifications/redux/noticeApi'
import { servicesApi } from 'feature/serviceCenters/redux/service.api'
import { userApi } from 'feature/user/redux/user.api'
import { lkmAppealsApi } from 'feature/lkmAppeals/redux/LkmAppeals.api'
import { registrationApi } from 'feature/registration/api/registrationLkmApi'
import { ordersApi } from 'feature/productOrder/redux/orders.api'
import { fitterApi } from 'feature/user/redux/fitter.api'
import { companyApi } from 'feature/company/redux/company.api'

const middleware: Middleware[] = [
  userApi.middleware,
  servicesApi.middleware,
  appealApi.middleware,
  myAddressesApi.middleware,
  ordersApi.middleware,
  noticeApi.middleware,
  lkmAppealsApi.middleware,
  registrationApi.middleware,
  fitterApi.middleware,
  companyApi.middleware,
]

export { middleware }
